export const fr = {
  employeeOpportunityEventTypeModal: {
    title: 'Sélectionnez votre type d\'événement',
    description: "Choisissez le type d'événement que vous souhaitez organiser",
    continue: 'Continuer',
    singleEvent: {
      label: 'Événement unique',
      description: 'Activités de bénévolat uniques avec une date de début et une heure de fin spécifiques.',
    },
    ongoingEvent: {
      label: 'Action communautaire',
      description: 'Campagnes flexibles comme des collectes de fonds et des marches auxquelles les bénévoles peuvent participer au fil du temps.',
    },
  },
}
